/**
 * Flag to turn on/off consent manger.
 *
 * https://app.optimizely.com/v2/projects/15340850549/features/22011580202#modal
 */
export const MARTECH_ENABLE_CONSENT_MANGER = 'martech_enable_consent_manger'

export const ENABLE_UTM_BACKUP_FEATURE = 'utm_backup_enabled'

/**
 * Feature flag to enable login journey ID tracking
 * @see {https://app.optimizely.com/v2/projects/15340850549/flags/manage/enable_login_journey_tracking_ceq2-876/rules/development}
 */
export const ENABLE_LOGIN_JOURNEY_TRACKING =
  'enable_login_journey_tracking_ceq2-876'
